import store from "Redux/Store/AppStore";

/** Typical GUID from PhysicianID / SignedBy */
const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const SIGNED_BY_DISPLAY_FIELD_NAMES = [
  "SignedByName",
  "PhysicianSignedByName",
  "SigningProviderName",
  "ProviderSignedName",
];

function trimStr(v: unknown): string {
  if (v === undefined || v === null) return "";
  return String(v).trim();
}

function displayNameFromLoggedInInfo(): string {
  try {
    const li = (store.getState() as { Reducer?: Record<string, unknown> })?.Reducer
      ?.loggedInInfo as Record<string, unknown> | undefined;
    if (!li || typeof li !== "object") return "";
    const parts = [
      li.physicianName,
      li.PhysicianName,
      li.providerName,
      li.fullName,
      li.name,
      [li.firstName, li.lastName].filter(Boolean).join(" "),
    ].map((x) => trimStr(x));
    return parts.find((p) => p.length > 0) ?? "";
  } catch {
    return "";
  }
}

function loggedInPhysicianId(): string {
  try {
    const li = (store.getState() as { Reducer?: Record<string, unknown> })?.Reducer
      ?.loggedInInfo as Record<string, unknown> | undefined;
    if (!li || typeof li !== "object") return "";
    return trimStr(
      li.physicianId ?? li.PhysicianId ?? li.userId ?? li.UserId ?? li.id
    );
  } catch {
    return "";
  }
}

/**
 * SignedBy is often stored as Physician GUID. Prefer human-readable name from
 * sibling API fields, session (same signer), or logged-in profile when IDs match.
 */
export function resolveSignedByDisplayName(
  signedByRaw: unknown,
  allFields?: { systemFieldName?: string; fieldValue?: unknown }[] | null
): string {
  const trimmed = trimStr(signedByRaw);
  if (!trimmed) return "";

  if (!UUID_RE.test(trimmed)) {
    return trimmed;
  }

  if (Array.isArray(allFields)) {
    for (const key of SIGNED_BY_DISPLAY_FIELD_NAMES) {
      const row = allFields.find((f) => f?.systemFieldName === key);
      const v = trimStr(row?.fieldValue);
      if (v) return v;
    }
  }

  try {
    const sid = trimStr(sessionStorage.getItem("PhysicianID"));
    const sname = trimStr(sessionStorage.getItem("PhysicianName"));
    if (sid && sname && sid.toLowerCase() === trimmed.toLowerCase()) {
      return sname;
    }
  } catch {
    /* private mode / SSR */
  }

  const loggedId = loggedInPhysicianId();
  if (loggedId && loggedId.toLowerCase() === trimmed.toLowerCase()) {
    const fromProfile = displayNameFromLoggedInInfo();
    if (fromProfile) return fromProfile;
  }

  return trimmed;
}
